import { toast } from "sonner";
import api from "@/lib/api";

// Open a private stored file (/api/files/{path}) by fetching it as a blob with
// credentials and handing the browser an object URL. A plain <a href> relies
// on the session cookie surviving a top-level navigation, which mobile
// browsers / home-screen web apps don't reliably do. The tab is opened
// synchronously inside the click gesture so mobile popup blockers don't kill it.
export async function openAuthFile(storagePath) {
  if (!storagePath) return;
  const win = window.open("", "_blank");
  try {
    const res = await api.get(`/files/${storagePath}`, { responseType: "blob", timeout: 30000 });
    const objectUrl = URL.createObjectURL(res.data);
    if (win) win.location = objectUrl;
    else window.location.assign(objectUrl);
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  } catch (e) {
    if (win) win.close();
    toast.error("Couldn't open the file. Please try again.");
  }
}

// onClick handler for an existing file <a>: keeps the href (styling, long-press
// "copy link") but routes the actual open through the authenticated blob fetch.
export function authFileClick(storagePath) {
  return (e) => {
    e.preventDefault();
    openAuthFile(storagePath);
  };
}
